"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputData = void 0;
const types_1 = require("Views/Partials/Components/PlusOneForm/types");
exports.inputData = {
    Email: {
        type: types_1.InputType.INPUT,
        id: types_1.InputIds.EMAIL,
        required: types_1.InputTypeRequired.TRUE,
        name: types_1.InputName.EMAIL,
        width: 'col-span-2',
    },
    Product: {
        type: types_1.InputType.SELECT,
        id: types_1.InputIds.PRODUCT,
        required: types_1.InputTypeRequired.TRUE,
        name: types_1.InputName.PRODUCT,
        width: 'max-lg:col-span-2 col-span-1',
    },
    EID: {
        type: types_1.InputType.INPUT,
        id: types_1.InputIds.EID,
        required: types_1.InputTypeRequired.FALSE,
        name: types_1.InputName.EID,
        width: 'max-lg:col-span-2 col-span-1',
    },
    UserConsent: {
        type: types_1.InputType.CHECKBOX,
        id: types_1.InputIds.CHECKBOX,
        required: types_1.InputTypeRequired.TRUE,
        name: types_1.InputName.CHECKBOX,
        width: 'col-span-2',
    },
    Subject: {
        type: types_1.InputType.INPUT,
        id: types_1.InputIds.SUBJECT,
        required: types_1.InputTypeRequired.TRUE,
        name: types_1.InputName.SUBJECT,
        width: 'col-span-2',
    },
    Description: {
        type: types_1.InputType.TEXTAREA,
        id: types_1.InputIds.DESCRIPTION,
        required: types_1.InputTypeRequired.TRUE,
        name: types_1.InputName.DESCRIPTION,
        width: 'col-span-2',
    },
};
